var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.589,
    height: 47.693,
    viewBox: "0 0 62.589 47.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(0 -13.93)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 0.77,
    cy: 0.77,
    r: 0.77,
    transform: "translate(0 60.045)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31186",
    "data-name": "Path 31186",
    d: "M7.863,145.5H6.745a.745.745,0,0,0,0,1.49H7.863a.745.745,0,0,0,0-1.49Z",
    transform: "translate(-3.765 -85.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31187",
    "data-name": "Path 31187",
    d: "M71.132,80.869a.745.745,0,0,0-1.032-.213L54.059,91.222a2.268,2.268,0,0,1-2.551.006L35.151,80.547a.746.746,0,1,0-.814,1.25l16.357,10.68a3.764,3.764,0,0,0,4.184-.009L70.919,81.9a.746.746,0,0,0,.213-1.033ZM44.04,92.1l-9.686,5.967a.746.746,0,1,0,.781,1.27l9.686-5.967a.746.746,0,0,0-.781-1.27ZM70.9,98.066,61.213,92.1a.746.746,0,1,0-.781,1.27l9.686,5.967a.746.746,0,0,0,.781-1.27Z",
    transform: "translate(-21.332 -44.543)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31188",
    "data-name": "Path 31188",
    d: "M47.256,45.01a3.005,3.005,0,0,0,2.832,2.006,2.956,2.956,0,0,0,.967-.163l21.963-7.59a2.981,2.981,0,0,0,1.835-3.791L70.681,23.506A3.005,3.005,0,0,0,67.849,21.5a2.957,2.957,0,0,0-.967.163l-21.964,7.59a2.981,2.981,0,0,0-1.835,3.791Zm-2.7-13.591a1.469,1.469,0,0,1,.846-.756l21.963-7.59a1.47,1.47,0,0,1,.481-.081A1.508,1.508,0,0,1,69.274,24l4.173,11.967a1.489,1.489,0,0,1-.914,1.889l-21.963,7.59a1.47,1.47,0,0,1-.481.081,1.508,1.508,0,0,1-1.425-1.006L44.49,32.552A1.472,1.472,0,0,1,44.558,31.419Z",
    transform: "translate(-26.929 -7.57)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M55.454,38.747,65.105,41.2a3.149,3.149,0,0,0,3.288-1.149l5.91-7.775a.745.745,0,0,0-1.186-.9l-5.91,7.775a1.663,1.663,0,0,1-1.735.606L55.822,37.3a.746.746,0,1,0-.367,1.446Zm14.964,1.575a.746.746,0,0,0,.528.913l5.588,1.492a.746.746,0,0,0,.384-1.442L71.33,39.794A.746.746,0,0,0,70.418,40.322Zm-7.862,2.325L58.83,47.123a.745.745,0,1,0,1.145.955L63.7,43.6a.745.745,0,1,0-1.145-.955Z",
    transform: "translate(-34.442 -13.582)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M156.863,145.5h-1.118a.745.745,0,0,0,0,1.49h1.118a.745.745,0,0,0,0-1.49Z",
    transform: "translate(-97.254 -85.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 0.77,
    cy: 0.77,
    r: 0.77,
    transform: "translate(61.05 60.045)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M65.564,79.278h-1.42a2.957,2.957,0,0,0,.406-1.494V53.17a2.991,2.991,0,0,0-2.98-2.984H58.432a4.431,4.431,0,0,1-1.323,1.492h4.461a1.493,1.493,0,0,1,1.49,1.492V77.785a1.493,1.493,0,0,1-1.49,1.492H19.843a1.493,1.493,0,0,1-1.49-1.492V53.17a1.493,1.493,0,0,1,1.49-1.492h6.6l-.52-1.492H19.843a2.991,2.991,0,0,0-2.98,2.984V77.785a2.957,2.957,0,0,0,.406,1.493h-1.42a.751.751,0,1,0,0,1.49H65.564a.751.751,0,1,0,0-1.49Z",
    transform: "translate(-9.412 -19.151)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19217",
    "data-name": "Group 19217",
    transform: "translate(3.705 15.675)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2889",
    "data-name": "Ellipse 2889",
    cx: 1.331,
    cy: 1.331,
    r: 1.331,
    transform: "translate(0 7.986)",
    fill: "#eb1000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 0.799,
    cy: 0.799,
    r: 0.799,
    transform: "translate(51.262 7.245)",
    fill: "#eb1000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 0.799,
    cy: 0.799,
    r: 0.799,
    transform: "translate(6.389 2.662)",
    fill: "#eb1000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a660ef2eb732e08e23e26477b2749859.svg";
export { ForwardRef as ReactComponent };